import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {POST_IEXAM_MEDICAL_CONDITIONS_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostIexamMedicalCondition = ({onSuccess, onError}: Input = {}) => {
  const postIexamMedicalCondition = async () => {
    await axiosClient.post(POST_IEXAM_MEDICAL_CONDITIONS_URL);
  };

  return useCustomMutation(postIexamMedicalCondition, {
    onSuccess,
    onError,
  });
};
